import { render, staticRenderFns } from "./NewVote.vue?vue&type=template&id=21b7dc46&scoped=true&"
import script from "./NewVote.vue?vue&type=script&lang=js&"
export * from "./NewVote.vue?vue&type=script&lang=js&"
import style0 from "./NewVote.vue?vue&type=style&index=0&id=21b7dc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b7dc46",
  null
  
)

export default component.exports